import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useLocales } from '@/locales';
import EDSAuthForm from '@/pages/auth/components/EDSAuth/EDSAuthForm';
import AdminLoginForm from '@/pages/auth/components/AdminAuth/AdminLoginForm';
import ClientLoginForm from '@/pages/auth/components/ClientAuth/ClientLoginForm';
import { useAuthFlowStore } from '@/pages/auth/stores/authFlowStore';
import { AUTH_TYPES } from '@/pages/auth/constants/authConstants';

/**
 * UnifiedAuthCard - Main authentication container component
 *
 * Manages switching between three authentication methods:
 * - EDS (Electronic Digital Signature)
 * - Admin (email/password)
 * - Client (TIN/contractId)
 *
 * @component
 */
const UnifiedAuthCard = () => {
  const { translate } = useLocales();
  const { authType, setAuthType } = useAuthFlowStore();

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">
          {translate('welcome_back') || 'Welcome back'}
        </CardTitle>
        <CardDescription>
          {translate('choose_login_method_enter_credentials') ||
            'Choose your login method and enter credentials'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs value={authType} onValueChange={setAuthType} className="w-full">
          <TabsList className="grid w-full grid-cols-3 mb-4">
            <TabsTrigger value={AUTH_TYPES.EDS}>
              {translate('eds') || 'EDS'}
            </TabsTrigger>
            <TabsTrigger value={AUTH_TYPES.ADMIN}>
              {translate('admin') || 'Admin'}
            </TabsTrigger>
            <TabsTrigger value={AUTH_TYPES.CLIENT}>
              {translate('client') || 'Client'}
            </TabsTrigger>
          </TabsList>
          <TabsContent value={AUTH_TYPES.EDS}>
            <EDSAuthForm />
          </TabsContent>
          <TabsContent value={AUTH_TYPES.ADMIN}>
            <AdminLoginForm />
          </TabsContent>
          <TabsContent value={AUTH_TYPES.CLIENT}>
            <ClientLoginForm />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default UnifiedAuthCard;
